// extracted by mini-css-extract-plugin
module.exports = {"container":"container-module--container--3OTf8","row":"container-module--row--3m2fR"};